import { IconProps } from "./Icons";

export const IconPeople = ({
  width = 85,
  height = 72,
  isHovered = false,
  color = "white",
}: IconProps) => {
  if (isHovered) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 83 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M43.9599 43.1171C48.2283 40.4585 51.5148 36.4821 53.3221 31.7894C55.1294 27.0967 55.3591 21.9431 53.9765 17.1082C52.594 12.2734 49.6744 8.02029 45.6594 4.99249C41.6445 1.96469 36.7526 0.326904 31.7239 0.326904C26.6953 0.326904 21.8034 1.96469 17.7884 4.99249C13.7735 8.02029 10.8539 12.2734 9.47131 17.1082C8.08876 21.9431 8.3185 27.0967 10.1258 31.7894C11.933 36.4821 15.2195 40.4585 19.488 43.1171C12.4595 45.4179 6.13561 49.7167 1.05062 55.7683C0.585729 56.3212 0.359521 57.0361 0.421755 57.7558C0.483989 58.4755 0.829568 59.1409 1.38247 59.6058C1.93537 60.0707 2.6503 60.2969 3.36998 60.2347C4.08966 60.1725 4.75515 59.8269 5.22004 59.274C12.0511 51.1189 21.4655 46.6296 31.7069 46.6296C41.9484 46.6296 51.3627 51.1189 58.2108 59.274C58.6757 59.8269 59.3412 60.1725 60.0609 60.2347C60.7805 60.2969 61.4955 60.0707 62.0484 59.6058C62.6013 59.1409 62.9468 58.4755 63.0091 57.7558C63.0713 57.0361 62.8451 56.3212 62.3802 55.7683C57.2952 49.7167 50.9713 45.4179 43.9599 43.1171ZM14.0081 23.485C14.0081 19.9846 15.0462 16.5627 16.9909 13.6521C18.9357 10.7416 21.6999 8.4731 24.9339 7.13353C28.1679 5.79395 31.7265 5.44345 35.1598 6.12636C38.593 6.80927 41.7466 8.49492 44.2218 10.9701C46.697 13.4454 48.3827 16.599 49.0656 20.0322C49.7485 23.4654 49.398 27.024 48.0584 30.2581C46.7189 33.4921 44.4504 36.2563 41.5398 38.201C38.6293 40.1458 35.2074 41.1838 31.7069 41.1838C27.0146 41.1784 22.516 39.312 19.198 35.994C15.88 32.676 14.0136 28.1774 14.0081 23.485ZM81.2839 34.9416L70.3923 45.8331C70.1394 46.0863 69.8391 46.2871 69.5086 46.4242C69.178 46.5612 68.8237 46.6317 68.4659 46.6317C68.108 46.6317 67.7537 46.5612 67.4232 46.4242C67.0926 46.2871 66.7923 46.0863 66.5394 45.8331L61.0937 40.3874C60.5827 39.8764 60.2957 39.1835 60.2957 38.4609C60.2957 37.7384 60.5827 37.0454 61.0937 36.5345C61.6046 36.0236 62.2975 35.7365 63.0201 35.7365C63.7427 35.7365 64.4356 36.0236 64.9465 36.5345L68.4659 40.0572L77.431 31.0887C77.9419 30.5778 78.6349 30.2907 79.3574 30.2907C80.08 30.2907 80.7729 30.5778 81.2839 31.0887C81.7948 31.5996 82.0818 32.2926 82.0818 33.0151C82.0818 33.7377 81.7948 34.4307 81.2839 34.9416Z"
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 81 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.8854 51.0367C36.893 51.0367 44.1952 43.7346 44.1952 34.727C44.1952 25.7194 36.893 18.4172 27.8854 18.4172C18.8778 18.4172 11.5757 25.7194 11.5757 34.727C11.5757 43.7346 18.8778 51.0367 27.8854 51.0367Z"
        stroke={color}
        strokeWidth="6.69118"
        strokeMiterlimit="10"
      />
      <path
        d="M49.0254 19.0132C50.4672 18.6221 51.954 18.4218 53.4478 18.4172C57.7735 18.4172 61.9219 20.1356 64.9806 23.1942C68.0392 26.2529 69.7576 30.4014 69.7576 34.727C69.7576 39.0526 68.0392 43.201 64.9806 46.2597C61.9219 49.3184 57.7735 51.0367 53.4478 51.0367"
        stroke={color}
        strokeWidth="6.69118"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.30273 62.7675C7.8494 59.1435 11.2308 56.1857 15.1614 54.1438C19.0919 52.1019 23.4562 51.0359 27.8855 51.0359C32.3147 51.0359 36.679 52.1019 40.6095 54.1438C44.5401 56.1857 47.9215 59.1435 50.4682 62.7675"
        stroke={color}
        strokeWidth="6.69118"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.4478 51.0366C57.8774 51.0339 62.2425 52.0985 66.1735 54.1405C70.1045 56.1824 73.4856 59.1414 76.0305 62.7671"
        stroke={color}
        strokeWidth="6.69118"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
